import React from 'react'


const Header = () => {
  return (
    <div>
        {/* <div className="header">
            <h3>Welcome Admin</h3>
        </div> */}
    </div>
  )
}

export default Header